/** Situações do TipoClassificacao */
export interface TipoClassificacaoSituacao {
    id: number;
    nome: string;
}

export const tipoClassificacaoSituacaoAtivo: TipoClassificacaoSituacao = {id: 1, nome: 'Ativo'};
export const tipoClassificacaoSituacaoInativo: TipoClassificacaoSituacao = {id: 2, nome: 'Inativo'};

export const tipoClassificacaoSituacoes: TipoClassificacaoSituacao[] = [
    tipoClassificacaoSituacaoAtivo,
    tipoClassificacaoSituacaoInativo
];

/** Verifica se a situação informada é igual a Ativo */
export function isSituacaoAtivo(situacao: number): boolean {
    if (!situacao) {
        return false;
    }
    return situacao === tipoClassificacaoSituacaoAtivo.id;
}

/** Verifica se a situação informada é igual a Inativo */
export function isSituacaoInativo(situacao: number): boolean {
    if (!situacao) {
        return false;
    }
    return situacao === tipoClassificacaoSituacaoInativo.id;
}
